import { Locale } from "@shared/enums/general"
import { IntlKey } from "@shared/intl"
import { EN } from "@shared/intl/en_GB"
import { NL } from "@shared/intl/nl_NL"

interface Lang {
  locale: Locale
  messages: Record<IntlKey, string>
}

type LangConfig = Omit<Lang, "locale">

const LocaleConfig: Record<Locale, LangConfig> = {
  [Locale.En]: {
    messages: EN,
  },
  [Locale.Nl]: {
    messages: NL,
  },
}

export const getLocaleConfig = (locale: Locale): Lang => ({
  ...LocaleConfig[locale],
  locale,
})
